import {
    makeCall,
    makeAuthenticatedCall,
    formFormData,
} from '../commons/routes';

const ONBOARDING_REST_API_BASE_PATH = `${process.env.PUBLIC_URL}/api/onboarding/consultants`;

export const validateOnboardLink = (url, callback) =>
    makeCall(
        `${ONBOARDING_REST_API_BASE_PATH}/${url}/validate`,
        'POST',
        undefined,
        undefined,
        (urlStatusDetails) => callback(urlStatusDetails)
    );

export const authenticateOnboardLink = (url, payload, setAuth) =>
    makeCall(
        `${ONBOARDING_REST_API_BASE_PATH}/${url}/authenticate`,
        'POST',
        payload
    ).then((res) => {
        const { token } = res.data;
        setAuth({
            isAuthenticated: true,
            token: `Bearer ${token}`,
        });
    });

export const reportIssueWithOnboarding = (url, payload) =>
    makeCall(`${ONBOARDING_REST_API_BASE_PATH}/${url}/issue`, 'POST', payload);

/** api calls below this point requires authentication */

export const pingCheck = (url, authContext) =>
    makeAuthenticatedCall(
        `${ONBOARDING_REST_API_BASE_PATH}/${url}/ping`,
        'GET',
        undefined,
        authContext
    );

export const fetchDraft = (url, authContext, callback) =>
    makeAuthenticatedCall(
        `${ONBOARDING_REST_API_BASE_PATH}/${url}/draft`,
        'GET',
        undefined,
        authContext,
        callback
    );

export function fetchProjectCompanies(url, authContext, callback) {
    return makeAuthenticatedCall(
        `${ONBOARDING_REST_API_BASE_PATH}/${url}/projectCompanies`,
        'GET',
        undefined,
        authContext,
        callback
    );
}

export function fetchOQs(url, authContext, callback) {
    return makeAuthenticatedCall(
        `${ONBOARDING_REST_API_BASE_PATH}/${url}/oqs`,
        'GET',
        undefined,
        authContext,
        callback
    );
}

export function isPreviousTrainingValid(url, authContext, callback) {
    return makeAuthenticatedCall(
        `${ONBOARDING_REST_API_BASE_PATH}/${url}/complianceTraining/status`,
        'GET',
        undefined,
        authContext,
        callback
    );
}

export function markTrainingCompletion(url, authContext) {
    return makeAuthenticatedCall(
        `${ONBOARDING_REST_API_BASE_PATH}/${url}/complianceTraining/status/completed`,
        'PUT',
        undefined,
        authContext
    );
}

export function uploadResume(url, file, authContext) {
    return makeAuthenticatedCall(
        `${ONBOARDING_REST_API_BASE_PATH}/${url}/resume`,
        'POST',
        formFormData(file),
        authContext
    );
}

export function saveProgress(url, payload, authContext, callback) {
    return makeAuthenticatedCall(
        `${ONBOARDING_REST_API_BASE_PATH}/${url}/draft`,
        'PUT',
        payload,
        authContext,
        callback
    );
}

export function submitApplication(url, payload, authContext) {
    return makeAuthenticatedCall(
        `${ONBOARDING_REST_API_BASE_PATH}/${url}/application`,
        'POST',
        payload,
        authContext
    );
}

export function updateStatus(url, payload, authContext) {
    return makeAuthenticatedCall(
        `${ONBOARDING_REST_API_BASE_PATH}/${url}/status`,
        'PUT',
        payload,
        authContext
    );
}

export const logOnboardingUserAgentInfo = (url, payload, authContext) =>
    makeAuthenticatedCall(
        `${ONBOARDING_REST_API_BASE_PATH}/${url}/userAgent`,
        'POST',
        payload,
        authContext
    );

export const parseLinkedInResume = (url, file, authContext) =>
    makeAuthenticatedCall(
        `${ONBOARDING_REST_API_BASE_PATH}/${url}/parseLinkedInResume`,
        'POST',
        formFormData(file),
        authContext
    );

/**
 * Adding APIs for Digital signature related workflow
 */
export const getToPDigitalSignatureContract = (url, authContext) =>
    makeAuthenticatedCall(
        `${ONBOARDING_REST_API_BASE_PATH}/${url}/digitalSignature/contract`,
        'GET',
        undefined,
        authContext
    );

export const createToPDigitalSignatureContract = (url, authContext) =>
    makeAuthenticatedCall(
        `${ONBOARDING_REST_API_BASE_PATH}/${url}/digitalSignature/contract`,
        'POST',
        undefined,
        authContext
    );

export const getToPDigitalSignatureSigningUrl = (url, authContext) =>
    makeAuthenticatedCall(
        `${ONBOARDING_REST_API_BASE_PATH}/${url}/digitalSignature/contract/signingUrl`,
        'GET',
        undefined,
        authContext
    );
